var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgApproveDayOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2203_62393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3 14.875H3.29999C3.29999 11.5 4.48415 11.5 6.45832 11.5C10.8 11.5 7.46665 7.675 7.46665 5.83333C7.46665 4.94928 7.81784 4.10143 8.44296 3.47631C9.06809 2.85119 9.91593 2.5 10.8 2.5C11.684 2.5 12.5319 2.85119 13.157 3.47631C13.7821 4.10143 14.1333 4.94928 14.1333 5.83333C14.1333 7.675 10.8 11.5 15.1417 11.5C17.1158 11.5 18.3 11.5 18.3 14.875Z",
    stroke: "#002244",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96664 17.5H16.6333",
    stroke: "#002244",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2203_62393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6415 9.44624L20.6416 9.44641L21.1366 10.2014L21.1367 10.2015C21.266 10.3989 21.3214 10.6356 21.293 10.8698C21.2667 11.0868 21.1702 11.2886 21.0189 11.445L21.0126 11.4534L20.9797 11.484L20.9729 11.4902L20.9727 11.4905L20.9469 11.5144L20.8396 11.617C20.8391 11.6174 20.8387 11.6178 20.8383 11.6183C20.2237 12.2144 19.6277 12.8295 19.0512 13.4626L20.6415 9.44624ZM20.6415 9.44624C20.4997 9.2301 20.2796 9.07728 20.0276 9.01986C19.7756 8.96246 19.5112 9.00482 19.2898 9.13807M20.6415 9.44624L14.2112 13.1832M15.8344 17.6974L15.8344 17.6975C15.43 18.4039 14.4367 18.5651 13.8417 17.9463L15.8344 17.6974ZM15.8344 17.6974C16.6853 16.2108 17.961 14.6616 19.0512 13.4627L15.8344 17.6974ZM12.9002 12.2002C12.7147 12.061 12.4866 11.9905 12.2549 12.0009C12.0233 12.0113 11.8024 12.1019 11.6302 12.2572L11.6301 12.2573L10.6502 13.1412C10.6501 13.1412 10.6501 13.1413 10.6501 13.1413C10.5506 13.231 10.4701 13.3399 10.4135 13.4613C10.3568 13.5828 10.3252 13.7145 10.3204 13.8484C10.3157 13.9824 10.3379 14.1159 10.3858 14.2411C10.4337 14.3663 10.5062 14.4806 10.5992 14.5772L10.5992 14.5773L13.8414 17.946L13.9034 13.4846C14.0078 13.3816 14.1103 13.2812 14.2112 13.1832M12.9002 12.2002L12.6002 12.5998L12.8999 12.2L12.9002 12.2002ZM12.9002 12.2002L14.2112 13.1832M14.2112 13.1832C16.6346 10.8288 18.0636 9.87548 19.2898 9.13807M19.2898 9.13807L19.5475 9.56656L19.2895 9.13825C19.2896 9.13819 19.2897 9.13813 19.2898 9.13807Z",
    fill: "#28BA59",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2203_62393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.799988)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2203_62393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8.79999 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgApproveDayOff);
export default __webpack_public_path__ + "static/media/svg_approve_day_off.c7a064e5352ef1881e3ca68920cfe6c5.svg";
export { ForwardRef as ReactComponent };